import { render, staticRenderFns } from "./panelInfoProfile.vue?vue&type=template&id=aa22fef8&scoped=true"
import script from "./panelInfoProfile.vue?vue&type=script&lang=js"
export * from "./panelInfoProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa22fef8",
  null
  
)

export default component.exports